import { MessageDescriptor, defineMessage } from 'react-intl';
import { NotificationFeedListItemModel } from '../feed/item/map-notification-feed-item';
import { notificationWorkflowCategoryMessages } from '../workflows';

const demoTitleAod = defineMessage({
  id: 'notifications.tour.demo.aod.title',
  defaultMessage: 'Deficiencia AOD: Campaña verano',
});

const demoBodyAod = defineMessage({
  id: 'notifications.tour.demo.aod.body',
  defaultMessage: 'Se detectó una deficiencia en la pauta programada.',
});

const demoTitleUpload = defineMessage({
  id: 'notifications.tour.demo.upload.title',
  defaultMessage: 'Publicación en Youtube completada',
});

const demoTitleExport = defineMessage({
  id: 'notifications.tour.demo.export.title',
  defaultMessage: 'Exportación de evidencias lista',
});

const demoTimeRecent = defineMessage({
  id: 'notifications.tour.demo.time.recent',
  defaultMessage: 'hace 5 minutos',
});

const demoTimeHourAgo = defineMessage({
  id: 'notifications.tour.demo.time.hourAgo',
  defaultMessage: 'hace 1 hora',
});

const demoTimeYesterday = defineMessage({
  id: 'notifications.tour.demo.time.yesterday',
  defaultMessage: 'ayer',
});

/**
 * Static presentational rows for the notifications tour demo feed.
 * Non-interactive (no primary action / buttons); handlers are no-ops in the tour shell.
 */
export function getNotificationsTourDemoItems(
  formatMessage: (descriptor: MessageDescriptor) => string,
): NotificationFeedListItemModel[] {
  return [
    {
      id: 'tour-demo-aod',
      eyebrow: formatMessage(notificationWorkflowCategoryMessages.audit),
      title: formatMessage(demoTitleAod),
      bodyHtml: `<p>${formatMessage(demoBodyAod)}</p>`,
      timeLabel: formatMessage(demoTimeRecent),
      unread: true,
      avatarName: null,
      avatarSrc: null,
      buttons: [],
      hasAction: false,
      severity: 'warning',
    },
    {
      id: 'tour-demo-upload',
      eyebrow: formatMessage(notificationWorkflowCategoryMessages['social-upload']),
      title: formatMessage(demoTitleUpload),
      bodyHtml: null,
      timeLabel: formatMessage(demoTimeHourAgo),
      unread: true,
      avatarName: null,
      avatarSrc: null,
      buttons: [],
      hasAction: false,
      severity: 'success',
    },
    {
      id: 'tour-demo-export',
      eyebrow: formatMessage(notificationWorkflowCategoryMessages.audit),
      title: formatMessage(demoTitleExport),
      bodyHtml: null,
      timeLabel: formatMessage(demoTimeYesterday),
      unread: false,
      avatarName: null,
      avatarSrc: null,
      buttons: [],
      hasAction: false,
      severity: 'success',
    },
  ];
}
